import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: '',
    message: '',
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simulación de envío de formulario exitoso
    setFormStatus({
      submitted: true,
      success: true,
      message: '¡Gracias por tu reserva! Te contactaremos pronto para confirmar.'
    });
    
    // Resetear el formulario después de 3 segundos
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        guests: '',
        message: '',
      });
      setFormStatus({
        submitted: false,
        success: false,
        message: ''
      });
    }, 5000);
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="section-title inline-block">Reserva Tu Mesa</h2>
          <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
            Reserva con anticipación para asegurar tu lugar en La Barra Brava. Estaremos encantados de recibirte.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-marina-50 rounded-xl overflow-hidden shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* Form Section */}
              <div className="p-4 sm:p-6 md:p-8">
                {formStatus.submitted ? (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className={`text-center p-6 rounded-lg ${
                      formStatus.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}
                  >
                    <i className={`fas ${formStatus.success ? 'fa-check-circle' : 'fa-exclamation-circle'} text-4xl mb-4`}></i>
                    <p>{formStatus.message}</p>
                  </motion.div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                        Nombre completo *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-marina-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                          Email *
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-marina-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                          Teléfono *
                        </label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-marina-500 focus:border-transparent"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
                      <div>
                        <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
                          Fecha *
                        </label>
                        <input
                          type="date"
                          id="date"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-marina-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label htmlFor="time" className="block text-sm font-medium text-gray-700 mb-1">
                          Hora *
                        </label>
                        <input
                          type="time"
                          id="time"
                          name="time"
                          value={formData.time}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-marina-500 focus:border-transparent"
                        />
                      </div>
                      <div className="col-span-2 sm:col-span-1">
                        <label htmlFor="guests" className="block text-sm font-medium text-gray-700 mb-1">
                          # Personas *
                        </label>
                        <input
                          type="number"
                          id="guests"
                          name="guests"
                          value={formData.guests}
                          onChange={handleChange}
                          min="1"
                          max="20"
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-marina-500 focus:border-transparent"
                        />
                      </div>
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                        Mensaje o solicitudes especiales
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="4"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-marina-500 focus:border-transparent"
                      ></textarea>
                    </div>

                    <div className="pt-2">
                      <button type="submit" className="btn-primary w-full">
                        Confirmar Reserva
                      </button>
                    </div>
                  </form>
                )}
              </div>

              {/* Info Section */}
              <div className="bg-marina-800 text-white p-4 sm:p-6 md:p-8 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-bold mb-6">Información de Reservas</h3>

                  <div className="space-y-6">
                    <div className="flex items-start">
                      <i className="fas fa-clock text-marina-300 mt-1 mr-4"></i>
                      <div>
                        <h4 className="font-bold text-marina-100">Horarios de Reserva</h4>
                        <p className="text-sm text-marina-200 mt-1">
                          Almuerzo: 12:00 - 16:00 hrs<br />
                          Cena: 19:00 - 22:30 hrs
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <i className="fas fa-user-friends text-marina-300 mt-1 mr-4"></i>
                      <div>
                        <h4 className="font-bold text-marina-100">Tamaño de Grupos</h4>
                        <p className="text-sm text-marina-200 mt-1">
                          Aceptamos reservas de hasta 20 personas.<br />
                          Para grupos más grandes, contáctanos directamente.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <i className="fas fa-info-circle text-marina-300 mt-1 mr-4"></i>
                      <div>
                        <h4 className="font-bold text-marina-100">Política de Reservas</h4>
                        <p className="text-sm text-marina-200 mt-1">
                          Las reservas se mantienen hasta 15 minutos después de la hora reservada.<br />
                          Para cancelaciones, avísanos con al menos 3 horas de anticipación.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-marina-700">
                  <h4 className="font-bold text-marina-100 mb-2">¿Necesitas ayuda con tu reserva?</h4>
                  <p className="text-sm text-marina-200 mb-4">
                    Llámanos directamente o envíanos un WhatsApp:
                  </p>
                  <a 
                    href="tel:+56987654321" 
                    className="flex items-center text-white hover:text-marina-300 transition-colors duration-300"
                  >
                    <i className="fas fa-phone-alt mr-2"></i>
                    +56 9 8765 4321
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
